import { ReactComponent as ExcelSvg } from '../../../img/icons/excel.svg';
import { ReactComponent as WordSvg } from '../../../img/icons/word.svg';
import { ReactComponent as FileSvg } from '../../../img/icons/file.svg';

const IconCell = ({ value }) => {
    if (value.toUpperCase() === 'XLS') {
        return <ExcelSvg />;
    }

    if (value.toUpperCase() === 'DOC') {
        return <WordSvg />;
    }

    return <FileSvg />;
}

export default IconCell;